import Vue from 'vue';
import Vuex from 'vuex';
//单个模块的
import make from './modules/make.js';
//全局共用
import state from './asset/state.js';
import getters from './asset/getters.js';
import mutations from './asset/mutations.js';
import actions from './asset/actions.js';
//注册vuex
Vue.use(Vuex);
//实例化vuex
const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	modules:{
		make
	}
});
//抛出
export default store;


// WEBPACK FOOTER //
// ./src/store/store.js